import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from '../scan/styles.css';

/**
 * @author weishihuai
 * @date 2018/9/29
 * @time 9:32
 * @Description: 人脸识别认证成功页面
 */
const ScanSuccess = ({...props}) => {
    let data = props.data || {code: '1'};
    let image = data.image || null;
    let hasPhoto = data.hasPhoto;

    //code:1:不是今年的迎新的学生，2：已经报到，3：报到成功
    //xsid:学生ID,xb：性别,xm：姓名，xy：学院，zy：专业 image:身份证头像 hasPhoto:是否有学生照片

    return (
        <div>
            <div className={styles.photo}>
                {
                    data.code == '1' ? (null != image ? <img src={'data:image/jpeg;base64,' + image} error={require('./images/tou.jpg')} width="110" height="155"/> : <img src={require('./images/tou.jpg')} alt="" width="93" height="127"/>) :
                        hasPhoto ? <img src={'api/sm-student/openapi/getStudentPhoto?xsid=' + data.xsid} error={require('./images/tou.jpg')} width="93" height="127"/>
                            : (null != image) ? <img src={'data:image/jpeg;base64,' + image} error={require('./images/tou.jpg')} width="93" height="127"/> :
                            <img src={require('./images/tou.jpg')} width="93" height="127"/>
                }
            </div>
            <div className={styles.textBox}>
                <div className={classNames(styles.name, styles.tl_c)}>
                    {data.code != '1' ? ((data.xm || '') + '同学') : ''}
                </div>
                <div className={classNames(styles.major, styles.tl_c)}>
                    {data ? `${data.xy || ''} | ${data.zy || ''}` : ''}
                </div>
                {data.code == '1' && <div className={classNames(styles.result, styles.tl_c)}>很遗憾，您不是我校的新生！</div>}
                {data.code == '2' && <div className={classNames(styles.result, styles.tl_c)}>您已报到，不需要再次报到！</div>}
                {data.code == '3' && <div className={classNames(styles.result, styles.tl_c)}>恭喜你，报到成功啦！</div>}
            </div>
        </div>
    );
};

ScanSuccess.propTypes = {
    data: PropTypes.object
};

export default ScanSuccess;


// WEBPACK FOOTER //
// ./components/face/success/scanSuccess.js